// ============================================================================
// SUNBORN // COLOR-AWARE QUICK-ADD (v2, Aug 3 2026 PM)
// ----------------------------------------------------------------------------
// v2 CHANGE (one-click size select): per Captain's direction, the frosted-
// glass SIZE button itself now both selects AND adds-to-cart AND opens the
// minicart in one click — matching the Gymshark / Shopify-Dawn-quick-add
// pattern (comp-set research: Alo Yoga and Rhone skip grid quick-add
// entirely and push sizing to the PDP; Gymshark's grid quick-add is single-
// click select-and-add). SunBorn had drifted into a third, two-step pattern
// (select size, then separately click the cart icon) that matched neither
// camp and added friction. This version collapses it back to one click.
//
// The core "add this variant, refresh the minicart section, open reliably"
// logic is now a shared function on window.sunbornAddVariantAndOpenCart so
// both call sites — the size-button click handler in theme.liquid AND the
// compact cart-icon button here — use the exact same code path.
//
// The compact ".sunborn-grid-cart-btn" (injected by product.js's
// sunbornGridCartIcon IIFE, and duplicated inline in
// sunborn-collections-grid.liquid — same class name, so this one interceptor
// covers both) still exists as the add path for single-variant products
// (no frosted-size overlay renders for those) and as a manual fallback if a
// selection is already recorded on the card. It intercepts in the CAPTURE
// phase (same established pattern as sunbornMinicartIconGuard /
// sunbornUpsellInterceptor in product.js) so it wins the race against the
// older "first available variant" handlers still live in product.js and
// sunborn-collections-grid.liquid.
// ============================================================================
(function sunbornColorAwareQuickAddCore() {
  if (window.sunbornAddVariantAndOpenCart) return; // core already installed

  function openCartReliably() {
    var cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      // PATCH (Aug 3 2026): innerHTML replacement of the minicart header
      // (done just before this runs) destroys any listeners CartNotification
      // bound to the old nodes on construction. Rebind before opening —
      // same fix already present in theme.liquid's sunbornClearCart().
      cartNotification.querySelectorAll('.bls-minicart-wrapper .close-button').forEach(function(b) {
        b.replaceWith(b.cloneNode(true));
      });
      cartNotification.querySelectorAll('.bls-minicart-wrapper .close-button').forEach(function(b) {
        b.addEventListener('click', cartNotification.close.bind(cartNotification));
      });
      document.querySelectorAll('.bls-minicart-action, .close-cart').forEach(function(el) {
        el.replaceWith(el.cloneNode(true));
      });
      document.querySelectorAll('.bls-minicart-action, .close-cart').forEach(function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          if (cartNotification.notification.classList.contains('bls__opend-popup-header')) {
            cartNotification.close();
          } else {
            cartNotification.open();
          }
        });
      });
      if (typeof cartNotification.cartAction === 'function') cartNotification.cartAction();
    }
    setTimeout(function() {
      if (cartNotification && typeof cartNotification.open === 'function') {
        cartNotification.open();
      } else {
        var minicartLink = document.querySelector('.bls-minicart-action');
        if (minicartLink) minicartLink.click();
      }
      document.documentElement.classList.add('hside_opened');
      document.body.classList.add('hside_opened');
      var overlay = document.querySelector('.bls__overlay');
      if (overlay) overlay.classList.remove('d-none-overlay');
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }, 200);
  }

  // Shared add-and-open path. feedbackEl is optional — any element to apply
  // a brief opacity/pointer-events "working" state to (size pill or cart
  // icon, whichever triggered it).
  window.sunbornAddVariantAndOpenCart = function(variantId, feedbackEl) {
    if (!variantId) return;
    if (feedbackEl) {
      feedbackEl.style.opacity = '0.5';
      feedbackEl.style.pointerEvents = 'none';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function(r) { return r.json(); })
      .then(function() {
        if (feedbackEl) {
          feedbackEl.style.opacity = '1';
          feedbackEl.style.pointerEvents = 'auto';
        }
        return fetch('/cart?sections=form-mini-cart');
      })
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var html = sections['form-mini-cart'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var formMiniCart = document.getElementById('form-mini-cart');
          var freshForm = doc.getElementById('form-mini-cart');
          if (formMiniCart && freshForm) formMiniCart.innerHTML = freshForm.innerHTML;
        }
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          document.querySelectorAll('.cart-count, .h-count').forEach(function(el) {
            el.textContent = cart.item_count;
          });
        });
        openCartReliably();
      })
      .catch(function() {
        if (feedbackEl) {
          feedbackEl.style.opacity = '1';
          feedbackEl.style.pointerEvents = 'auto';
        }
      });
  };
})();

(function sunbornColorAwareQuickAddCartIcon() {
  if (window.__sunbornColorAwareQuickAddActive) return;
  window.__sunbornColorAwareQuickAddActive = true;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.sunborn-grid-cart-btn');
    if (!btn) return;
    var card = btn.closest('.bls__product-item');
    if (!card) return;
    var variantId = card.getAttribute('data-selected-variant-id');
    if (!variantId) return; // no selection recorded — let the original handler run unimpeded (single-variant products)

    e.preventDefault();
    e.stopImmediatePropagation();

    window.sunbornAddVariantAndOpenCart(variantId, btn);
  }, true); // capture phase — must run before the bubble-phase handlers bound in product.js
})();
